import getArchiveFanoutMailboxInfoForResult from './getArchiveFanoutMailboxInfoForResult';
import type { ClientItemId } from 'owa-client-ids';
import type { ItemRow } from 'owa-graph-schema';
import type { TableView } from 'owa-mail-list-store';
import getMailboxInfo from 'owa-mail-mailboxinfo/lib/getMailboxInfo';

export default function getItemClientIdForSearchResult(
    item: ItemRow,
    tableView: TableView
): ClientItemId {
    const archiveMailboxInfo = getArchiveFanoutMailboxInfoForResult(item.MailboxGuids);
    if (archiveMailboxInfo) {
        return {
            Id: item.ItemId.Id,
            mailboxInfo: archiveMailboxInfo,
        };
    }

    return {
        Id: item.ItemId.Id,
        mailboxInfo: item.ItemId.mailboxInfo ?? getMailboxInfo(tableView),
    };
}
